import { useNavigate } from "react-router-dom";

export const BackButton = (props) => {
    const navigate = useNavigate();
    let {
        onClick,
        title,
    } = props;

    return (
        <button
            onClick={onClick || (() => navigate(-1))}
            className="flex items-center justify-center w-10 h-10 rounded-lg border-2 border-gray-300 text-gray-600 hover:border-app-primary hover:text-app-primary transition-colors duration-200"
            title={title || "Retour"}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                />
            </svg>
        </button>
    );
};

